export const scrollToId = (id: string) => {
  if (document && typeof document.getElementById === 'function') {
    const element = document.getElementById(id);
    if (element && element.scrollIntoView) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
    }
  }
};
